import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { SenderWithTrackingEvents } from '@/types/sender.types';
import { axiosClient } from '@/utils/apiClient';
import { useSenderStore } from './useSenderStore';

export interface UseSenderReturn {
  senderId: string | null;
}

export const useSender = (): UseSenderReturn => {
  const { senderId } = useSenderStore();

  return {
    senderId,
  };
};

export const useSenderQuery = (
  options?: Omit<
    UseQueryOptions<SenderWithTrackingEvents, Error>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<SenderWithTrackingEvents, Error> => {
  const {
    senderId,
    actions: { setHasContactFormSubmitted },
  } = useSenderStore();

  return useQuery({
    queryKey: ['sender', senderId],
    queryFn: async (): Promise<SenderWithTrackingEvents> => {
      const response = await axiosClient.get(
        `/LiveChatV2/Public/Senders/${senderId}`,
      );

      if (response.data) {
        setHasContactFormSubmitted(
          !!response.data.sender?.metadata?.contact_form,
        );
      }

      return response.data as SenderWithTrackingEvents;
    },
    enabled: !!senderId,
    ...options,
  });
};
